import { clients } from '../app/data';

// Was getting `Object.values is not a function` on netlify,
// so changed to this.
export default Object.keys(clients).map((key) => clients[key]);



// WEBPACK FOOTER //
// ./src/layouts/clients.js